

export class WorkstationLevelGarmentsCompletion {
    workstationId: string;
    workstationDesc: string;
    plannedGarments: number;
    completedGarments: number;
    actualTime: number;
    spentTime: number;
    operation: string;

    constructor( workstationId: string,
        workstationDesc: string,
        plannedGarments: number,
        completedGarments: number,
        actualTime: number,
        spentTime: number,
        operation: string) {
            this.workstationId = workstationId;
            this.workstationDesc = workstationDesc;
            this.plannedGarments = plannedGarments;
            this.completedGarments = completedGarments;
            this.actualTime =actualTime;
            this.spentTime = spentTime;
            this.operation = operation;
    }
}